import React from 'react'
import { useStyles } from './styles'
import { MovementRecordCard } from '../../AnimalDetails/MovementRecordCard'
import { Loading } from 'src/components'
import { useGetAnimalRecordsList } from 'src/hooks/api/animal'
import { IAnimal } from 'src/dto/animal.dto'

interface IMovementRecord {
  data?: IAnimal
}

export const MovementRecord: React.FC<IMovementRecord> = ({ data }) => {
  const styles = useStyles()

  const { data: animalRecordsList = [], isLoading, isError, refetch, isFetching } = useGetAnimalRecordsList(data?.id!)

  if (isLoading || isFetching || isError) {
    return (
      <section>
        <h1 className={styles.movementRecordTitle}>{data?.nome || ''}</h1>
        <div className={styles.loadingContiner}>
          <Loading isError={isError} refetch={refetch} />
        </div>
      </section>
    )
  }

  return (
    <section>
      <h1 className={styles.movementRecordTitle}>{data?.nome || ''}</h1>
      <div className={styles.movementRecordContent}>
        {animalRecordsList && animalRecordsList.length ? (
          animalRecordsList.map((record) => <MovementRecordCard key={record.id} data={record} />)
        ) : (
          <p style={{ color: '#000' }}>Animal sem registros.</p>
        )}
      </div>
    </section>
  )
}
